<template>
  <div class="expense-save">
    <b-row>
      <b-col>
        <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
      </b-col>
    </b-row>
    <h1 v-if="id == undefined">Criar Despesa</h1>
    <h1 v-else>Editar Despesa</h1>
    <router-link :to="`/checklist/expense/list/`">
      <b-button size="sm"> Voltar </b-button>
    </router-link>

    <b-row class="mt-4">
      <b-col cols="6">
        <ExpenseCrud :expense.sync="expense" />
      </b-col>
    </b-row>

    <b-button @click="save"> Salvar </b-button>
  </div>
</template>

<script>
export default {
  name: "ExpenseSave",
  props: {
    id: String,
  },
  components: {
    ExpenseCrud: () => import("@/components/expenses/ExpenseCrud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Despesa salva com sucesso",
      },
      expense: {
        id: 0,
        active: true,
        description: "",
        initDate: "",
        endDate: "",
        value: 0,
        costCenter: "",
        expenseType: 0,
        apportionment: 0,
        typeOfApportionment: 0,
        expenseProfiles: [],
      },
    };
  },
  methods: {
    loadData() {
      this.$apiVehicle
        .get("/expense/get/" + this.id)
        .then((response) => {
          this.expense = response.data;
          this.modelstate = {};
        })
        .catch((error) => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    save() {
      this.$apiVehicle
        .post("/expense/save", this.expense)
        .then((response) => {
          this.$refs.successFadeAlert.show();
          if (this.id == undefined) {
            this.expense = {
              id: 0,
              active: true,
              description: "",
              initDate: "",
              endDate: "",
              value: 0,
              costCenter: "",
              expenseType: 0,
              apportionment: 0,
              typeOfApportionment: 0,
              expenseProfiles: [],
            };
          }
        })
        .catch((error) => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
  },
  computed: {
    // Add your computed properties here
  },
  created() {
    if (this.id != undefined) {
      this.loadData();
    }
  },
};
</script>

<style scoped>
.expense-save {
  /* Add your styles here */
}
</style>